import { render } from "./RoleOnly.vue?vue&type=template&id=4e539b59"
import script from "./RoleOnly.vue?vue&type=script&lang=js"
export * from "./RoleOnly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__